/* eslint-disable max-len */
/**
 * A map associating proposal properties with their unique key strings.
 */
export const ProposalPropertyMap = {};
/**
 * A list of recognized proposal properties.
 */
export const ProposalPropertyList = [
    {
        "key": "commentLength",
        "type": "number",
        "group": "general",
        "inputType": "integer",
        "default": 1000,
        "title": "Comment length",
        "description": "The maximum length allowed for comments.",
        "multilingual": false,
        "hiddenFromInterface": true, // in fact deprecated
    }, {
        "key": "title",
        "type": "string",
        "group": "general",
        "inputType": "text",
        "default": null,
        "title": "Proposal title",
        "description": "The title that will be shown on the card.",
        "multilingual": true,
    }, {
        "key": "description",
        "type": "string",
        "group": "general",
        "inputType": "textarea",
        "default": null,
        "title": "Proposal description",
        "description": "A short description that will be shown on the card.",
        "multilingual": true,
    }, {
        "key": "showFullImage",
        "type": "boolean",
        "group": "general",
        "inputType": "switch",
        "default": false,
        "title": "Show full image",
        "description": "Select this if you want the whole image to be visible. If this is not selected, the image will be scaled to fill out the card.",
        "multilingual": false,
    }, {
        "key": "featureImageAsset",
        "type": "resourceId",
        "isResourceId": "asset",
        "inputType": "imageAssetId",
        "group": "general",
        "default": null,
        "title": "Proposal card image asset",
        "description": "An image asset to use as the card background.",
        "multilingual": false,
    }, {
        "key": "featureImageAssetUrl",
        "type": "url",
        "default": null,
        "multilingual": false,
        "hiddenFromInterface": true,
    }, {
        "key": "featureImage",
        "type": "url",
        "group": "general",
        "inputType": "imageUrl",
        "default": null,
        "title": "Proposal card image url",
        "description": "A URL for an image to use as the card background. This will not be used if the image asset option is selected.",
        "multilingual": false,
    },
];
for (const property of ProposalPropertyList) {
    if (ProposalPropertyMap[property.key]) {
        throw new Error(`Duplicate proposal property key name "${property.key}".`);
    }
    ProposalPropertyMap[property.key] = property;
}
//# sourceMappingURL=proposalProperties.js.map